import { render, staticRenderFns } from "./app-detail-sync.vue?vue&type=template&id=1ff4602b";
import script from "./app-detail-sync.vue?vue&type=script&lang=js";
export * from "./app-detail-sync.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;